(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CopyrightDetailController', CopyrightDetailController);

    CopyrightDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Copyright'];

    function CopyrightDetailController($scope, $rootScope, $stateParams, previousState, entity, Copyright) {
        var vm = this;

        vm.copyright = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:copyrightUpdate', function(event, result) {
            vm.copyright = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
